import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-card" }
const _hoisted_2 = { class: "modal-card-head modal-style" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "modal-card-title has-text-white text-center" }, " RESET YOUR PASSWORD ", -1)
const _hoisted_4 = { class: "modal-card-body modal-style" }
const _hoisted_5 = { class: "field margin-t-24" }
const _hoisted_6 = { class: "control has-icons-left" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-envelope" })
], -1)
const _hoisted_8 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_9 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: `modal ${_ctx.active ? 'is-active' : ''}`
  }, [
    _createVNode("div", {
      class: "modal-background",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-reset')))
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode("header", _hoisted_2, [
        _hoisted_3,
        _createVNode("button", {
          class: "delete border-solid",
          "aria-label": "close",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle-reset')))
        })
      ]),
      _createVNode("section", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.email = $event)),
              class: 
                `input is-background-black has-text-white ${
                  _ctx.error == '' ? '' : 'is-danger'
                }`
              ,
              type: "email",
              placeholder: "Email",
              "data-testid": "reset-password-email-input"
            }, null, 2), [
              [_vModelText, _ctx.email]
            ]),
            _hoisted_7
          ]),
          (_ctx.error)
            ? (_openBlock(), _createBlock("p", _hoisted_8, " This email is invalid "))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("button", {
            class: "button is-background-green no-border margin-t-24",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sendEmail && _ctx.sendEmail(...args))),
            "data-testid": "reset-password-login-submit-button"
          }, " Send email ")
        ])
      ])
    ])
  ], 2))
}